import {
  DomainProbeResult,
  QueryProbeDomainArgs,
} from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getProbeDomainKey } from '../../utils/keys/domain.key.js'

export const useProbeDomain = (options?: {
  variables: QueryProbeDomainArgs
  useQueryOptions?: UseQueryOptions<DomainProbeResult>
}) => {
  const { variables, useQueryOptions } = options || {}
  const { client } = useTribeClient()

  return useQuery<DomainProbeResult>(
    getProbeDomainKey({ variables }),
    () => client.network.probeDomain(variables),
    useQueryOptions,
  )
}
